export default "__VITE_ASSET__WVMHJodo__"